import { render } from "./SelectPaymentType.vue?vue&type=template&id=33cec0ae"
import script from "./SelectPaymentType.vue?vue&type=script&lang=js"
export * from "./SelectPaymentType.vue?vue&type=script&lang=js"

import "./SelectPaymentType.vue?vue&type=style&index=0&id=33cec0ae&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__